import { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import useSessionPersistedState from '../../hooks/useSessionPersistedState';

const DEFAULT_DATE_RANGE = { created_on: { type: 'date', start: null, end: null } };
const DEFAULT_PAGINATION = { page: 0, size: 10 };

const useBulkUploadFilters = ({ persistKey } = {}) => {
  const [selectedFilter, setSelectedFilter] = useSessionPersistedState(
    persistKey ? `${persistKey}:selectedFilter` : undefined,
    'filename',
  );
  const [dateRange, setDateRange] = useSessionPersistedState(
    persistKey ? `${persistKey}:dateRange` : undefined,
    DEFAULT_DATE_RANGE,
  );
  const [selectedStatus, setSelectedStatus] = useSessionPersistedState(
    persistKey ? `${persistKey}:selectedStatus` : undefined,
    '',
  );
  const [pagination, setPagination] = useSessionPersistedState(
    persistKey ? `${persistKey}:pagination` : undefined,
    DEFAULT_PAGINATION,
  );
  const [searchTerm, setSearchTerm] = useSessionPersistedState(persistKey ? `${persistKey}:searchTerm` : undefined, '');

  const buildQuery = () => {
    const query = { ...pagination };
    if (searchTerm) {
      query[selectedFilter] = searchTerm;
    }
    if (!isEmpty(query)) {
      query.status = selectedStatus;
    }
    if (dateRange?.document_date?.start || dateRange?.document_date?.end) {
      const { start, end } = dateRange.document_date;
      const cleanDateObject = { ...(start && { start }), ...(end && { end }) };
      if (Object.keys(cleanDateObject).length) {
        query.created_on = JSON.stringify(cleanDateObject);
      }
    }

    return query;
  };

  const [currentQuery, setCurrentQuery] = useState(() => buildQuery());

  useEffect(() => {
    setCurrentQuery(buildQuery());
  }, [selectedFilter, selectedStatus, dateRange, pagination, searchTerm]);

  const handleFilterChange = (event) => setSelectedFilter(event.target.value);

  const handleSearchChange = (event) => setSearchTerm(event.target.value);

  const handleDateRangeChange = (newDateRange) => setDateRange(newDateRange);

  const handlePaginationChange = (page, limit) => setPagination({ page: page, size: limit });

  const handleStatusChange = (event) => setSelectedStatus(event.target.value);

  const handleSearchKeyPress = (event) => {
    if (event.key === 'Enter') {
      setCurrentQuery(buildQuery());
    }
  };

  return {
    searchTerm,
    selectedStatus,
    selectedFilter,
    currentQuery,
    dateRange,
    handleFilterChange,
    handleSearchChange,
    handleSearchKeyPress,
    handleDateRangeChange,
    handlePaginationChange,
    handleStatusChange,
  };
};

export default useBulkUploadFilters;
